import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 30,
  medium: 23,
  small: 16,
  xSmall: 12
};
const YoutubeFilledIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26 19.0734C26 23 22.2091 23 22.2091 23H7.78991C4 23 4 19.0734 4 19.0734V10.9266C4 7 7.78991 7 7.78991 7H22.2091C26 7 26 10.9266 26 10.9266V19.0734ZM19.2717 15.0114L12.0687 10.6292V19.3922L19.2717 15.0114Z",
        fill: "currentColor"
      }
    )
  );
};
YoutubeFilledIcon.iconName = "YoutubeFilledIcon";

export { YoutubeFilledIcon };
